interface Props {
  color?: string
  width?: number
  height?: number
}

export const Post1Icon = ({ color = '#6F6F6F', width = 21, height = 21 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.875 0C19.876 0 20.6875 0.811484 20.6875 1.8125V18.875C20.6875 19.876 19.876 20.6875 18.875 20.6875H1.8125C0.811484 20.6875 0 19.876 0 18.875V1.8125C0 0.811484 0.811484 0 1.8125 0H18.875ZM6.94336 8.88184C6.63609 8.60254 6.16692 8.60013 5.85645 8.87598L1 13.1924V18.875C1 19.3237 1.36377 19.6875 1.8125 19.6875H18.875C19.3237 19.6875 19.6875 19.3237 19.6875 18.875V12.5625L15.4678 9.39746C15.1665 9.1717 14.7492 9.1828 14.46 9.42383L11.624 11.7861L13.9609 13.9111C14.1652 14.0968 14.1806 14.4128 13.9951 14.6172C13.8095 14.8214 13.4934 14.8368 13.2891 14.6514L6.94336 8.88184ZM1.8125 1C1.36377 1 1 1.36377 1 1.8125V11.8545L5.19238 8.12891C5.88485 7.51352 6.92965 7.51938 7.61523 8.14258L10.877 11.1074L13.8203 8.65527C14.4656 8.11782 15.3954 8.09396 16.0674 8.59766L19.6875 11.3115V1.8125C19.6875 1.36377 19.3237 1 18.875 1H1.8125Z"
        fill={color}
      />
    </svg>
  )
}
